// Default-Dev (npm run start:bpweb): spricht die dev-api (DB-Gateway, Bearer-Token,
// KEINE DB-Credentials im Bundle) statt der Prod-API. Prod ist NICHT betroffen —
// Prod-Builds ersetzen diese Datei per fileReplacements durch environment.prod.ts,
// und `ng build` nutzt defaultConfiguration=production. Inhaltlich identisch zu
// environment.dev-new.ts; das dev-new-Profil ist damit nur noch ein expliziter Alias.
export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-api.luzula.de',
  dbAppName: 'boden',
  dbBaseName: 'boden',
  keycloakRealm: 'luzula', // dev-boden.luzula.de (boden = umbenannte luzula-Realm-Variante)
};
